module.exports = __webpack_public_path__ + "static/9-1-4f76b30b6ffebcff25f88be2cfc0cf5e.jpg";